const getPartnerContact = (willCase) => {
  return willCase.attributes.contacts?.find((contact) => {
    return contact.id !== willCase.attributes.contactId
  })
}

export default getPartnerContact
